import { render } from "./ModalDocumentCancel.vue?vue&type=template&id=5f22bcda&scoped=true"
import script from "./ModalDocumentCancel.vue?vue&type=script&lang=js"
export * from "./ModalDocumentCancel.vue?vue&type=script&lang=js"

import "./ModalDocumentCancel.vue?vue&type=style&index=0&id=5f22bcda&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f22bcda"]])

export default __exports__